import { render, staticRenderFns } from "./ShopItemView.vue?vue&type=template&id=1cd0ebd2"
import script from "./ShopItemView.vue?vue&type=script&lang=js"
export * from "./ShopItemView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports